export function getGivenName(displayName: string | null | undefined): string {
  const normalized = displayName?.trim();
  if (!normalized) return 'there';

  const [, givenNames] = normalized.split(',', 2);
  const preferredSource = givenNames?.trim() || normalized;
  const [firstName] = preferredSource.split(/\s+/);

  return firstName?.replace(/^[,\s]+|[,\s]+$/g, '') || 'there';
}
